module.exports = __webpack_public_path__ + "static/img/banner-doctor.49a49b37.png";